// @flow

export const extractIddZone = (type: string): ?string => {
  const zoneMatch = type.match(/\bIDD(SMS|VOICE|DATA)([A-Z])/);
  return zoneMatch && zoneMatch[2];
};

export const extractIddZoneFromArrayElements = (array: Object[], elementKey: string): ?string => {
  const iddItem = array.find(item => item[elementKey] && item[elementKey].includes('IDD'));
  if (iddItem) {
    return extractIddZone(iddItem[elementKey]);
  }

  return null;
};
